import React, { useContext } from 'react';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from 'modules/Devices/DeviceFullInfo/deviceFullInfoState/deviceFullInfoContext';
import Field from './Field';
import style from './BankSetting.module.scss';

const BankSetting: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	return (
		<>
			{deviceForFullInfo?.deviceBankSettings.length ? (
				deviceForFullInfo?.deviceBankSettings.map((setting, i) => {
					return (
						<div className={!i ? '' : style.topMargin} key={setting.id}>
							<div className={style.row}>
								<Field
									value={setting.restaurantBankSetting.acquirerName}
									label="restaurantBankSettingsLabel"
								/>
								<Field value={setting.terminalId} label="terminalIdLabel" />
							</div>
							{setting.m4BankSettingCredentials && (
								<div className={style.row}>
									<Field value={setting.m4BankSettingCredentials.login} label="APIProxiLoginLabel" />
									<Field
										value={setting.m4BankSettingCredentials.password}
										label="APIProxiPasswordHashLabel"
									/>
								</div>
							)}
							{setting.toucanBankSettingCredentials && (
								<div className={style.row}>
									<Field value={setting.toucanBankSettingCredentials.login} label="loginLabel" />
									<Field
										value={setting.toucanBankSettingCredentials.password}
										label="passwordLabel"
									/>
								</div>
							)}
						</div>
					);
				})
			) : (
				<div className={style.row}>
					<Field value={null} label="restaurantBankSettingsLabel" />
					<Field value={null} label="terminalIdLabel" />
				</div>
			)}
		</>
	);
};

export default BankSetting;
